import './newsletter.less'

import {Image, m} from '@codeurs/front'
import sendIcon from 'assets/images/send.png'
import {CheckIcon} from 'assets/inline-icons'
import {Field, Form, Formik} from 'formik'
import requestService from 'mithril/request/request'
import React, {useState} from 'react'
import {t} from 'util/i18n'
import {style} from 'util/style'
import {FormCheckbox} from 'views/forms/formcheckbox'
import {Theme} from 'views/theme'
import {InputField} from './inputfield'

const styles = style('newsletter')
const request = requestService(window, Promise).request

export type NewsLetterType = {
	title: string
	text: string
	firstname_placeholder: string
	lastname_placeholder: string
	email_placeholder: string
	organization_placeholder: string
	agree: string
	thanks: string
	show: boolean
}
type FormData = {
	email?: string
	firstname?: string
	lastname?: string
	organization?: string
	agree?: boolean
}
export const Newsletter: React.FC<
	NewsLetterType & {language: string; children?: React.ReactNode; mod?: 'home'}
> = ({language, children, mod, ...newsletter}) => {
	const {title, thanks, text} = newsletter

	const [isCompleted, setCompleted] = useState(false)

	if (!newsletter.show && !children) return null

	return (
		<Theme.Container class={styles.mod(mod)}>
			{newsletter.show && (
				<div class={styles('container')} id="newsletter">
					<div class={styles('container-left')}>
						<div class={styles('container-left-content')}>
							<Theme.H2>{title}</Theme.H2>
							<div>{text}</div>
						</div>
					</div>
					<div class={styles('container-right')}>
						{isCompleted ? (
							<div class={styles('container-thanks')}>
								<div class={styles('container-thanks-check')}>
									<CheckIcon />
								</div>
								<Theme.Wysiwyg>{thanks}</Theme.Wysiwyg>
							</div>
						) : (
							<ViewForm
								language={language}
								setCompleted={() => setCompleted(true)}
								{...newsletter}
							/>
						)}
					</div>
				</div>
			)}
			{children}
		</Theme.Container>
	)
}
const ViewForm: React.FC<
	NewsLetterType & {language: string; setCompleted: (isTrue: boolean) => void}
> = ({language, setCompleted, ...newsletter}) => {
	const [error, setError] = useState('')
	return (
		<Formik<FormData>
			initialValues={{}}
			validateOnBlur={false}
			validateOnChange={false}
			onSubmit={(values: FormData, formik) => {
				setError('')
				request({
					method: 'POST',
					url: '/api/newsletter/' + language,
					data: values
				})
					.then(res => setCompleted(true))
					.catch(error => {
						if ('general' in error) setError(error.general.message)
						formik.setErrors(JSON.parse(error.message))
					})
			}}
		>
			{({errors}) => {
				return (
					<Form class={styles('form')}>
						<div class={styles('form-row')}>
							<InputField name="firstname" icon="user">
								<Field
									name="firstname"
									type="firstname"
									required
									placeholder={newsletter.firstname_placeholder}
									aria-label="firstname input"
								/>
							</InputField>
							<InputField name="lastname" icon="user">
								<Field
									name="lastname"
									type="lastname"
									required
									placeholder={newsletter.lastname_placeholder}
									aria-label="lastname input"
								/>
							</InputField>
						</div>
						<InputField name="email" icon="envelope">
							<Field
								name="email"
								type="email"
								required
								placeholder={newsletter.email_placeholder}
								aria-label="email input"
							/>
						</InputField>
						<div class={styles('form-row')}>
							<InputField
								name="organization"
								icon="briefcase"
								class={styles('form-row-input')}
							>
								<Field
									name="organization"
									type="organization"
									placeholder={newsletter.organization_placeholder}
									aria-label="organization input"
								/>
							</InputField>
							<Theme.Button
								class={styles('submit')}
								as="button"
								type="submit"
								aria-label={t('newsletter.submit')}
							>
								<Image {...sendIcon} />
							</Theme.Button>
						</div>
						{error && (
							<div class={styles('form-error')}>{t('newsletter.error')}</div>
						)}
						<div class={styles('form-checkbox')}>
							<FormCheckbox
								required
								type="checkbox"
								name="agreement"
								value="yes"
								label={newsletter.agree}
							/>
						</div>
					</Form>
				)
			}}
		</Formik>
	)
}
